export default "__VITE_ASSET__Ctemz3Wz__"